<script lang="ts" setup>
  import { useId } from 'reka-ui';
  import type { HTMLAttributes } from 'vue';
  import { provide } from 'vue';

  import { cn } from '@ui/utils/utils';

  import { FORM_ITEM_INJECTION_KEY } from './injectionKeys';

  const props = withDefaults(
    defineProps<{
      class?: HTMLAttributes['class'];
      layout?: 'horizontal' | 'vertical';
      spaceEvenly?: boolean;
    }>(),
    {
      layout: 'vertical',
    },
  );

  const id = useId();
  provide(FORM_ITEM_INJECTION_KEY, id);
</script>

<template>
  <div
    data-slot="form-item"
    :class="
      cn(
        'grid gap-2',
        layout === 'vertical'
          ? 'flex flex-col gap-y-1.5'
          : 'grid grid-cols-[max-content_1fr] gap-2 items-center',
        spaceEvenly && layout === 'horizontal' ? 'grid-cols-2! gap-x-20' : '',
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>
